"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Header = ({ logoUrl, name, websiteUrl }) => {
    const defaultWebsiteUrl = 'https://feesable.com.au';
    return ((0, jsx_runtime_1.jsx)("header", { className: "header", children: (0, jsx_runtime_1.jsx)("div", { className: "max-w-7xl mx-auto flex items-center md:justify-between flex-col md:flex-row p-3", children: (0, jsx_runtime_1.jsx)("a", { href: websiteUrl !== null && websiteUrl !== void 0 ? websiteUrl : defaultWebsiteUrl, target: "_blank", rel: "noreferrer", children: logoUrl && ((0, jsx_runtime_1.jsx)("img", { className: "logo md:inline-block", src: logoUrl, alt: name })) }) }) }));
};
exports.Header = Header;
